import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const HazardIdentification = ({ selectedHazards, onHazardToggle, hazardCategories, errors }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
          <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Hazard Identification</h2>
          <p className="text-sm text-muted-foreground">Select all potential hazards associated with this work</p>
        </div>
      </div>
      <CheckboxGroup error={errors?.hazards}>
        <div className="space-y-6">
          {hazardCategories?.map((category) => (
            <div key={category?.id} className="space-y-3">
              <div className="flex items-center gap-2 pb-2 border-b border-border">
                <Icon name={category?.icon} size={18} color="var(--color-primary)" />
                <h3 className="font-medium text-foreground">{category?.name}</h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pl-4">
                {category?.hazards?.map((hazard) => (
                  <Checkbox
                    key={hazard?.id}
                    label={hazard?.name}
                    description={hazard?.description}
                    checked={selectedHazards?.includes(hazard?.id)}
                    onChange={(e) => onHazardToggle(hazard?.id, e?.target?.checked)}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </CheckboxGroup>
      {selectedHazards?.length > 0 && (
        <div className="mt-6 bg-warning/5 border border-warning/20 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="ShieldAlert" size={18} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-medium text-foreground mb-1">
                {selectedHazards?.length} Hazard{selectedHazards?.length !== 1 ? 's' : ''} Identified
              </p>
              <p className="text-muted-foreground">
                Additional safety equipment and precautions will be required based on selected hazards.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HazardIdentification;